import { render, staticRenderFns } from "./InvoiceScreen.vue?vue&type=template&id=5c7477db"
import script from "./InvoiceScreen.vue?vue&type=script&lang=js"
export * from "./InvoiceScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports